/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

const scopes = {
  billing: true,
  billingOverview: true,
  customers: true,
  customersView: true,
  dashboard: true,
  invoices: true,
  invoiceImports: true,
  invoicesView: true,
  Overview: true,
  plans: true,
  plansView: true,
  prices: true,
  subscriptions: true,
};

export { scopes as default };
